var core = module.exports = {};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef